import { memo } from 'react';
import type { CellContext, TableOptions } from '@tanstack/react-table';
import { Switch as MuiSwitch } from '@mui/material';

interface Props<T, P> {
  checked: boolean;
  row: CellContext<T, P>;
  isClickable?: boolean;
  onClick?: (row: T, cell: keyof P, newRow?: TableOptions<T>['data'][number]) => unknown;
}

const SwitchBase = <T, P>({ checked, onClick, row, isClickable }: Props<T, P>) => {
  return (
    <MuiSwitch
      onChange={() => {
        const newRow = {
          ...row.row.original,
          [row.column.id]: !checked,
        };

        onClick && onClick(row.row.original, row.column.id as keyof P, newRow);
      }}
      checked={checked}
      disabled={!isClickable}
    />
  );
};

export const Switch = memo(SwitchBase) as typeof SwitchBase;
